import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

import { LoadingSpinnerComponent } from '@shared/ui/loading-spinner/loading-spinner.component';

// Rendered only as a ComponentPortal by LoadingScreenService, so its presence is the loading state:
// it takes no inputs and reads nothing.
@Component({
  selector: 'ess-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrl: './loading-screen.component.scss',
  imports: [LoadingSpinnerComponent, TranslocoDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingScreenComponent {}
